const escapeRegExp = function (string: string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
}

export const replaceAll = function (str: string | String, match: string, replacement: string) {
    return str.replace(new RegExp(escapeRegExp(match), 'g'), () => replacement);
}